import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Mentees from '.';
import Export from './Export';
import MenteeDetail from './[id]';
import EditInformationPage from './[id]/EditInformation';
import ReviewPage from './[id]/interviews/[id]';

const MentorsRoutes: FC = () => {
  return (
    <Routes>
      <Route path="" element={<Mentees />} />
      <Route path="/export" element={<Export />} />
      <Route path="/:id/interviews/:interviewId" element={<ReviewPage />} />
      <Route path="/:id/*" element={<MenteeDetail />} />
      <Route path="/:id/edit-information" element={<EditInformationPage />} />
    </Routes>
  );
};

export default MentorsRoutes;
